import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3b6f588"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]


import { platIcon } from '@/store/modules/goods'
import { useSite, isEN, isJA } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['type', 'url', 'data', 'underline', 'country'],
  setup(__props) {

const props = __props


const goUrl = () => {
  if (!props?.url) return
  if (props.type === 'YS') return
  const isSniffProduct = (props.url ?? '').includes('s.theckb.com')
  if (isSniffProduct && props.url.includes('goods')) {
    const splitGoodsUrl = props.url.split('goods/')
    const jumpAddress = `${window.location.origin}/${isJA() ? 'ja' : isEN() ? 'en' : 'ko'}/goods/${window.encodeURIComponent(splitGoodsUrl[splitGoodsUrl.length - 1])}`
    if (isEN() && (props.type === 'VC' || props.type === 'WS')) {
      return
    }
    props.url && window.open(jumpAddress)
  } else {
    if (isEN() && (props.type === 'VC' || props.type === 'WS')) {
      return
    }
    if (props.type === '-') {
      window.open(props.url)
      return
    }
    props.url && window.open((platIcon[props.type] || props.country === 'KR') ? props.url : null)
  }
}

const match = (type: any) => {
  if (props.country === 'KR') {
    return 'https://static-s.theckb.com/BusinessMarket/Client/country/korea_icon.png'
  }
  // 1688国家货盘
  if (type === 'NAM') {
    return 'https://static-s.theckb.com/BusinessMarket/SEO/AM.png'
  }
  if (type === 'AMT') {
    return `https://static-s.theckb.com/BusinessMarket/icon/1688selected/goods-selected-logo-${useSite()}.png`
  }
  if (type === 'AM') {
    return 'https://static-s.theckb.com/BusinessMarket/icon/1688.svg'
  }
  return type in platIcon ? platIcon[type] : (props.underline ? platIcon.underline : platIcon.ckb)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(_unref(useSite)() + ' logo-icon'),
    onClick: goUrl,
    target: "_blank"
  }, [
    (__props.type)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          referrerPolicy: "no-referrer",
          src: match(__props.type),
          style: _normalizeStyle(_unref(isEN)() && __props.type === 'AMT' ? 'height:26px;margin-top:-5px;' : '')
        }, null, 12, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})